<div class="container">
  <ion-searchbar
    placeholder="Maschinen durchsuchen"
    show-clear-button="focus"
    (ionInput)="handleSearchInput($event)"
  ></ion-searchbar>
  <div class="custom-table">
    <div class="row header">
      <div class="col" style="display: flex; align-items: center">
        Inv.-Nr.
        <ion-icon
          size="small"
          style="color: black; cursor: default"
          name="caret-up-outline"
        ></ion-icon>
      </div>
      <div class="col grow" style="display: flex; align-items: center">
        Name
      </div>

      <div class="col">Art</div>
      <div class="col">Status</div>
    </div>

    <div
      class="row"
      *ngFor="let wd of filteredEntries"
      (click)="openDetailModal(wd.id)"
    >
      <div class="col grow">{{ wd.inventoryNumber }}</div>
      <div class="col">{{ wd.manufacturer }} {{ wd.type }}</div>
      <div class="col grow">{{ wd.category }}</div>
      <div class="col grow centered">
        @if(wd.inspectionNecessary){
        <ion-icon
          style="font-size: 20px"
          class="red"
          name="close-circle-outline"
        ></ion-icon>
        } @if(!wd.inspectionNecessary && (wd.nextManualInspection != null ||
        !wd.inspectionFree)){
        <ion-icon
          style="font-size: 20px"
          class="green"
          name="checkmark-circle-outline"
        ></ion-icon>
        } @if(wd.daysUntilNextInspection !== null && !wd.inspectionFree){ ({{
          wd.daysUntilNextInspection
        }})}
      </div>
    </div>
  </div>
  <lib-table-legend [items]="[4, 5]"></lib-table-legend>
</div>
